<template>
  <div class="ai-results">
    <!-- <span @click="openNewPage()">openNewPage</span> -->
    <div class="ai-results-content">
      <div class="ai-results-info">
        <!-- <div class="ai-results-info-top" v-if="Article">
          <div class="ai-results-copy" @click="copyText">复制</div>
          <div class="ai-results-source" v-if="EventList.length > 0">
            <el-popover placement="bottom" trigger="click">
              <div class="sourceList">
                <div
                  class="sourceItem"
                  v-for="(item, index) in EventList"
                  :key="index"
                  @click="open(item)"
                  :title="item.title"
                >
                  {{ index + 1 }}、{{ item.title }}
                </div>
              </div>
              <el-button class="sourceNum" slot="reference" type="text"
                >来源 {{ EventList && EventList.length }} 个</el-button
              >
            </el-popover>
          </div>
        </div> -->
        <div class="ai-results-article" v-if="Article">
          <div
            class="ai-results-info-con"
            v-html="Article"
            @click="hidePopup"
          ></div>
          <div
            class="popup"
            v-show="showPopup"
            v-loading="loading"
            :style="popupStyle"
          >
            <div><i class="el-icon-link"></i></div>
            <div>
              <!-- 新建详情页 -->
              <!-- <h4 @click="openNewPage(articleID)">{{ floatingArticle.title }}</h4> -->
              <!-- 右侧打开详情页 -->
              <h4 @click="openRightSidebar(articleID)">{{ floatingArticle.title }}</h4>
              <div class="popup-info">
                <span>{{ floatingArticle.source }}</span> | 
                <span>{{ floatingArticle.time }}</span>
              </div>
              <p
                class="popup-item"
                :title="item"
                v-for="(item, index) in popupContentList"
                :key="index"
                
              >
                {{ item }}
              </p>
            </div>

            <!-- <div class="popup-url" >
              {{ source }}
            </div> -->
          </div>
        </div>

        <div v-else style="margin: 20px 0">
          <el-skeleton v-show="isNodata" :rows="6" animated />
        </div>
      </div>

      <div class="ai-results-tab" v-if="!isSkeleton">
        <div
          v-for="(item, index) in tabList"
          :key="index"
          class="ai-results-tab-item"
          :class="{ tabActive: tabActive == index }"
          @click="changeTab(index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="ai-results-chart" v-if="!NoContextError">
        <div v-if="!isSkeleton">
          <event-new-context
            :ClassifyEventTimeData="ClassifyEventTime"
            :communityData="CommunityData"
            v-show="tabActive == 0"
          ></event-new-context>
          <information-graph
            v-show="tabActive == 1"
            ref="graph"
            :CrossCommunity="CrossCommunity"
          ></information-graph>
          <event-context
            v-show="tabActive == 2"
            :aiResultData="EventList"
            :communityData="CommunityData"
          ></event-context>
        </div>
        <div v-else>
          <el-skeleton :rows="6" animated />
        </div>
      </div>
      <div class="ai-results-chart" v-else>
        <el-empty description="暂无社区脉络，请试试其他关键词分析"></el-empty>
      </div>
    </div>

    <el-drawer
      :visible.sync="dialogDetailVisible"
      title=""
      size="35%"
      direction="rtl"
      :before-close="handleDetailDialogClose"
    >
      <article-detail :articleDetail="articleDetail"></article-detail>
    </el-drawer>
  </div>
</template>

<script>
import eventBus from "@/pages/EventBus";
import EventContext from "@/pages/views/project/EventContext.vue";
import EventNewContext from "@/pages/views/project/components/EventNewContext.vue";
import Organizations from "@/pages/views/project/Organizations.vue";
import RelatedFigures from "@/pages/views/project/RelatedFigures.vue";

import InformationGraph from "@/pages/views/project/components/InformationGraph.vue";

import Region from "@/pages/views/project/Region.vue";
import TypingEffect from "@/pages/views/project/TypingEffect.vue";

import { GetQuoteParagraphs, GetJfrbArticle } from "@/api/index.js";

import ArticleDetail from "@/pages/views/project/components/ArticleDetail.vue";

export default {
  components: {
    EventContext,
    EventNewContext,
    Organizations,
    RelatedFigures,
    Region,
    TypingEffect,
    ArticleDetail,
    InformationGraph
  },
  props: {
    EventList: {
      type: Array
    },
    Article: {
      type: String
    },
    AiResultData: {
      type: Object
    },
    isNodata: {
      type: Boolean
    },
    isSkeleton: {
      type: Boolean
    },
    CommunityData: {
      type: Array
    },
    CrossCommunity: {
      type: Object
    },
    ClassifyEventTime: {
      type: Array
    },
    NoContextError: {
      type: Boolean
    }
  },
  data() {
    return {
      articleDetail: {},
      dialogDetailVisible: false, // 右侧详情弹窗

      // tabList: ["事件脉络", "相关组织", "相关人物"],
      tabList: ["事件脉络", "信息图谱", "事件总结"],
      tabActive: 0,
      loading: false,
      showPopup: false,
      popupContentList: [],
      source: "",
      popupStyle: {
        top: "0px",
        left: "0px"
      },
      articleID: "",

      highlightData: "", // 存储高亮的数据

      // 浮层dialog
      floatingArticle: {
        title: "",
        source: "",
        time: ""
      }
    };
  },
  watch: {
    Article: {
      handler(newVal, oldVal) {
        this.addEventListeners();
      },
      deep: true
    },
    AiResultData: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal.place) != "{}") {
          this.tabList = ["事件脉络", "信息图谱"];
        }
      },
      deep: true
    }
  },
  mounted() {
    document.addEventListener("click", this.hidePopup);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hidePopup);
  },
  methods: {
    /**
     * @param 定义跳转到 articleDetails 路由的方法
     */
    openNewPage(articleID) {
      // eventBus.$emit("pushMsg11", true);
      if (this.highlightData) {
        sessionStorage.setItem(
          "highlightData",
          JSON.stringify(this.highlightData)
        );
      }

      // console.log("@", this.highlightData);
      // 4517242131610460023

      const routeUrl = this.$router.resolve({
        name: "articleDetails",
        params: { id: this.articleID }
      });
      window.open(routeUrl.href, "_blank");
    },

    /**
     * @param articleID 打开右侧边栏查看文章详情
     */
    openRightSidebar(articleID) {
      GetJfrbArticle({ id: this.articleID })
        .then((res) => {
          console.log("🚀 ~ openRightSidebar ~ res:", res);
          if (res.succeed) {
            let html = this.brightenKeyword(
              res.data.contenttxt,
              this.highlightData
            );
            this.articleDetail = {
              title: res.data.title,
              class1: res.data.class1,
              papername: res.data.papername,
              updatetime: res.data.updatetime,
              degree: res.data.degree,
              url: res.data.url,
              contenttxt: html
            };
            this.dialogDetailVisible = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleDetailDialogClose() {
      this.dialogDetailVisible = false;
    },
    showTagPopup(event) {
      this.showPopup = true;
      this.popupStyle.left = `${event.clientX + 10}px`;
      // this.popupStyle.top = `${event.clientY - 50}px`;
      this.popupStyle.top = `${event.clientY - 50 + window.scrollY}px`;

      this.loading = true;
      // 阻止事件冒泡到 document 上
      event.stopPropagation();
      this.articleID = event.target.dataset.id;
      let params = {
        id: this.articleID,
        sentence: event.target.dataset.sentence
      };
      GetQuoteParagraphs(params)
        .then((res) => {
          this.highlightData = res.data;

          this.$nextTick(() => {
            this.popupContentList = res.data.slice(0, 2) || [];
          });

          this.source = "查看文章详情";

          GetJfrbArticle({ id: params.id })
            .then((res) => {
              this.floatingArticle = {
                title: res.data.title,
                source: res.data.papername,
                time: res.data.updatetime
              };
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    hidePopup() {
      this.showPopup = false;
      this.source = "";
      this.articleID = "";
      this.popupContentList = [];
    },
    addEventListeners() {
      this.$nextTick(() => {
        const tags = document.querySelectorAll(".fw-tag");
        tags.forEach((tag) => {
          tag.addEventListener("click", (event) => this.showTagPopup(event));
        });
      });
    },
    // 智能问答弹框结束
    handleClick(tab, event) {
      console.log(tab, event);
    },
    copyText() {
      var text = document.querySelector(".ai-results-info-con");
      var range = document.createRange();
      range.selectNode(text);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      this.$message.success("复制成功");
    },
    open(item) {
      window.open(item.url, "_blank");
    },
    changeTab(index) {
      this.tabActive = index;
    },
    // checkLink() {
    //   // window.open(this.source, "_blank");
    //   window.open(
    //     "https://www.hzfanews.com/v2/WebPageEmbed.aspx?ArticleSequenceId=" +
    //       this.articleID,
    //     "_blank"
    //   );
    // },
    brightenKeyword(_html, data) {
      let keys = data;
      if (_html) {
        keys.forEach((item, index) => {
          if (item) {
            var reg = new RegExp("(<[^>]*?)(" + item + ")([^<]*?>)", "gmi");
            var _htmlMatch = _html.match(reg);
            if (_htmlMatch) {
              _htmlMatch.forEach(function (element) {
                var newHtml = element.replace(
                  new RegExp(item, "gmi"),
                  "!@#whhxdd!@#"
                );
                _html = _html.replace(element, newHtml);
              });
            }
            _html = _html.replace(
              new RegExp(item, "gmi"),
              '<font class="highlight">' + item + "</font>"
            );
            _html = _html.replace(/!@#whhxdd!@#/gi, item);
          }
        });
      }
      return _html;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-results {
  padding: 0 30px 200px;
  .ai-results-info {
    border-bottom: 1px solid #ebeef5;
    padding-top: 20px;
    padding-bottom: 40px;
    .ai-results-info-top {
      display: flex;
      align-items: baseline;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.6);
      margin-bottom: 5px;
      .ai-results-copy {
        background: url("../../../assets/jfrb/copy.png") no-repeat left;
        padding-left: 20px;
        cursor: pointer;
      }
      .ai-results-source {
        background: url("../../../assets/jfrb/source.png") no-repeat left;
        padding-left: 20px;
        cursor: pointer;
        margin-left: 20px;
        color: rgba(0, 0, 0, 0.6);
      }
      .ai-results-source:hover {
        background: url("../../../assets/jfrb/source-blue.png") no-repeat left;
        color: rgba(62, 157, 211, 1);
      }
    }
    ::v-deep .ai-results-info-con {
      font-size: 16px;
      color: #333333;
      line-height: 33px;
      // 第一个H3标签
      div:first-child {
        h3:first-child {
          font-size: 24px;
        }
      }

      h1,
      h2,
      h3,
      h4,
      h5 {
        margin-top: 20px;
      }
      strong {
        margin-top: 20px;
      }
      hr {
        margin-top: 20px;
        border: none;
        border-top: 1px #dedede solid;
      }
    }
  }
  .ai-results-tab {
    padding-top: 20px;
    display: flex;
    .ai-results-tab-item {
      width: 130px;
      height: 36px;
      color: #444;
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      margin-right: 5px;
      cursor: pointer;
      background-color: #f7f7f7;
      transition: all 0.2s ease-in-out;
      &:hover {
        color: #222;
        background-color: #f1f1f1;
      }
    }
    .tabActive {
      background: #5b8eac;
      color: #fff;
      font-weight: 600;
      &:hover {
        color: #fff;
        background-color: #4a7b98;
      }
    }
  }
  .ai-results-chart {
    margin-top: 40px;
    width: 100%;
  }
}
.sourceItem {
  color: rgba(122, 122, 122, 1);
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 5px;
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sourceItem:hover {
  color: rgba(62, 157, 211, 1);
}
.sourceNum {
  color: rgba(0, 0, 0, 0.6) !important;
}
.sourceNum:hover {
  color: #3e9dd3 !important;
}
.ai-results-article {
  // position: relative
}
.popup {
  max-width: 500px;
  min-width: 200px;
  min-height: 90px;
  position: absolute;
  padding: 20px;
  z-index: 2;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-start;
  i{
    color: #3e9dd3;
    font-size: 16px;
    font-weight: 500;
    margin-right: 5px;
    padding-top: 3px;

  }
  h4{
    color: #3e9dd3;
    cursor: pointer;
  }
  .popup-info {
    font-size: 12px;
    color: #7a7a7a;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  .popup-item {
    // cursor: pointer;
    font-size: 14px;
    color:#333;
    margin-bottom: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .popup-url {
    cursor: pointer;
    color: #3e9dd3;
  }
}
</style>
